import { Editor, Tldraw, createShapeId } from 'tldraw';
import 'tldraw/tldraw.css';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getProjectById, Project } from '../services/projectService';
import { useState, useEffect, useRef } from 'react';
import { AnalysisCardShapeUtil } from '../tldraw-components/AnalysisCardShapeUtil';

const customShapeUtils = [AnalysisCardShapeUtil];

export default function CanvasPage() {
    const { projectId } = useParams<{ projectId: string }>();
    const [editor, setEditor] = useState<Editor | null>(null);
    const shapesCreated = useRef(false);

    const { data: project, isLoading, error } = useQuery<Project, Error>({
        queryKey: ['project', projectId],
        queryFn: () => getProjectById(projectId!),
        enabled: !!projectId,
    });

    useEffect(() => {
        if (!editor || !project || shapesCreated.current) return;

        const results = project.analysis_results;
        if (!results || results.length === 0) return;

        editor.run(() => {
            const shapesToCreate = results.map((result, index) => {
                return {
                    id: createShapeId(),
                    type: 'analysis-card' as const,
                    x: (index % 5) * 220,
                    y: Math.floor(index / 5) * 120,
                    props: {
                        text: result.matrix_item.articulo,
                        color: index % 2 === 0 ? '#BDE0FE' : '#FFC8DD', // Alternating colors
                    },
                    meta: {
                        analysisResultId: result.id,
                    },
                };
            });
            editor.createShapes(shapesToCreate);
        });
        
        shapesCreated.current = true;

    }, [editor, project]);


    if (isLoading) return <div style={{ padding: '20px' }}>Loading Canvas...</div>
    if (error) return <div style={{ padding: '20px' }}>Error loading project data for canvas.</div>

	return (
        <div style={{ position: 'fixed', inset: 0 }}>
            <Tldraw onMount={setEditor} shapeUtils={customShapeUtils} />
        </div>
    )
} 